import React from 'react';
import PropTypes from 'prop-types';
import ArrowDown from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import ArrowRight from 'material-ui/svg-icons/hardware/keyboard-arrow-right';

const arrowStyle = { color: '#000', marginLeft: -5, cursor: 'pointer' };

class ArrowExpandButton extends React.Component {
  state = {
    collapsed: this.props.collapsed
  };

  toogleCollapse = () => this.setState(oldState => ({ collapsed: !oldState.collapsed }));

  handleExpand = () => {
    this.props.onExpand();
    this.toogleCollapse();
  };

  handleCollapse = () => {
    this.props.onCollapse();
    this.toogleCollapse();
  };

  render() {
    const { collapsed } = this.state;
    return (
      <div style={ this.props.style }>
        { collapsed && <ArrowRight onClick={ this.handleExpand } style={ arrowStyle } /> }
        { !collapsed && <ArrowDown onClick={ this.handleCollapse } style={ arrowStyle } /> }
      </div>
    );
  }
}

ArrowExpandButton.propTypes = {
  onExpand: PropTypes.func.isRequired,
  onCollapse: PropTypes.func.isRequired,
  collapsed: PropTypes.bool.isRequired,
  style: PropTypes.object
};

export default ArrowExpandButton;



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/invoiceLinesDetail/c/arrowExpandButton/ArrowExpandButton.js